import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';

const color = "#234E70"; // Replace with your exact orange if needed

const LoadingSpinner: React.FC<{ loadingText?: string }> = ({ loadingText }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color }} spin />} />
        {loadingText && <span>{loadingText}</span>}
    </div>
);

export default LoadingSpinner;
